<template>
  <div class="email-activities">
    <div v-if="dataLength">
      <div
        v-for="(item, index) in emailActivities"
        :key="index"
        class="email-activities__container">
        <accordian
          :expanded="item.expanded"
          :item="item"
          :index="index"
          @onCardToggle="onAccordianToggle">
          <div
            slot="accordian-header-content"
            class="email-activities__container__accordian-header">
            <div class="email-activities__container__accordian-header__content">
              <div
                class="email-activities__container__accordian-header__content__info">
                <span
                  class="email-activities__container__accordian-header__content__info__name--bold">
                  {{ item.from_name }}
                </span>
                <span
                  v-tooltip="formatDate(item.message_date)"
                  class="email-activities__container__accordian-header__content__info__name--ellipsis">
                  {{ formatDate(item.message_date) }}
                </span>
              </div>
              <div
                class="email-activities__container__accordian-header__content__info">
                <span
                  class="email-activities__container__accordian-header__content__info__name--grey">
                  From
                </span>
                <span
                  v-tooltip="formatDate(item.from_address)"
                  class="email-activities__container__accordian-header__content__info__name--ellipsis">
                  {{ item.from_address }}
                </span>
              </div>
              <div
                class="email-activities__container__accordian-header__content__info">
                <span
                  class="email-activities__container__accordian-header__content__info__name--grey">
                  To
                </span>
                <span
                  v-tooltip="formatDate(item.to_address)"
                  class="email-activities__container__accordian-header__content__info__name--ellipsis">
                  {{ item.to_address }}
                </span>
              </div>
              <div
                class="email-activities__container__accordian-header__content__info subject">
                <span
                  class="email-activities__container__accordian-header__content__info__name--grey">
                  Subject
                </span>
                <span
                  v-tooltip="formatDate(item.subject)"
                  class="email-activities__container__accordian-header__content__info__name--ellipsis">
                  {{ item.subject }}
                </span>
              </div>
            </div>
          </div>
          <div
            v-if="item.expanded && emailContent"
            slot="accordian-body"
            class="email-activities__container__accordian-body">
            <div class="email-activities__container__accordian-body__item">
              <span
                class="email-activities__container__accordian-body__item__title">
                Case number
              </span>
              <span
                class="email-activities__container__accordian-body__item__value">
                {{ caseData.case_number }}
              </span>
            </div>
            <div class="email-activities__container__accordian-body__item">
              <span
                class="email-activities__container__accordian-body__item__title">
                Case record type
              </span>
              <span
                class="email-activities__container__accordian-body__item__value">
                {{ caseData.case_record_type }}
              </span>
            </div>
            <div class="email-activities__container__accordian-body__item">
              <span
                class="email-activities__container__accordian-body__item__title">
                Status
              </span>
              <span
                class="email-activities__container__accordian-body__item__value">
                {{ emailStatusMapping[emailContent.status] }}
              </span>
            </div>
            <div class="email-activities__container__accordian-body__item">
              <span
                class="email-activities__container__accordian-body__item__title">
                Subject
              </span>
              <span
                class="email-activities__container__accordian-body__item__value">
                {{ emailContent.subject }}
              </span>
            </div>
            <div class="email-activities__container__accordian-body__item">
              <span
                class="email-activities__container__accordian-body__item__title">
                Email content
              </span>
              <div
                class="email-activities__container__accordian-body__item__value"
                v-html="emailContent.html_body"></div>
            </div>
            <attachment-list
              v-if="emailContent.attachments && emailContent.attachments.length"
              :attachments="getFormattedAttachments(emailContent.attachments)"
              title="Email attachments"
              has-download
              :has-delete="false"
              v-on="$listeners" />
          </div>
        </accordian>
      </div>
    </div>
    <h4 v-else class="email-activities__not-found">No Email Found</h4>
  </div>
</template>

<script>
//Actions
import { disputeActions } from "@/actions";

// Util
import { format } from "date-fns";
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import { getMsalIdToken } from "@/utils/helpers";

// constants
import { emailStatusMapping } from "@/config/isrConstant.js";

export default {
  name: "EmailActivities",
  props: {
    emailActivities: {
      type: Array,
      default: () => [],
    },
    caseData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      emailContent: null,
      emailStatusMapping,
      emailCache: [],
    };
  },
  computed: {
    dataLength() {
      return this.emailActivities?.length > 0;
    },
  },
  methods: {
    formatDate(date) {
      try {
        return date
          ? format(new Date(`${date}`), "dd-MMM-yyyy hh:mm a")
          : "N/A";
      } catch (err) {
        return date;
      }
    },
    async onAccordianToggle(clickedItem, index) {
      const emailDataFromCache = this.emailCache.find(
        (item) => item.id === clickedItem.id
      );
      if (!clickedItem?.expanded && !emailDataFromCache) {
        try {
          const { data } = await AxiosFetchForMsal(
            disputeActions.getEmailActivityContent(
              clickedItem.id,
              `Bearer ${await getMsalIdToken(this)}`
            )
          );
          this.emailContent = data;
          this.emailCache.push(data);
          event.stopPropagation();
        } catch (error) {
          console.error(error);
        }
      } else {
        this.emailContent = emailDataFromCache;
      }
      let newArray = [...this.emailActivities];
      newArray[index] = {
        ...clickedItem,
        expanded: !clickedItem.expanded,
      };
      this.emailActivities = newArray;
    },
    getFormattedAttachments(data) {
      return data.map((item) => ({
        fileName: item?.name,
        type: item?.file_extension || item?.name.split(".").pop(),
        id: item?.id,
      }));
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";
.email-activities {
  background: var(--Gray-50);
  &__not-found {
    color: var(--Gray-900);
    margin: 1rem;
  }

  &__container {
    margin: 1rem 0;
    cursor: pointer;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      width: 20px;
      height: 20px;
      background-color: var(--Blue-800);
      border-radius: 24px;
      margin-top: 32px;
    }

    &::after {
      content: "";
      height: calc(100% + 8px);
      position: absolute;
      top: 42px;
      left: 9px;
      width: 2px;
      background-color: var(--Blue-800);
    }

    &:last-child {
      margin-bottom: 0;

      &::after {
        content: none;
      }
    }

    &__accordian-header {
      display: flex;
      align-items: center;

      &__content {
        display: flex;
        align-items: center;

        @include media("<tablet") {
          flex-direction: column;
        }

        &__info {
          display: flex;
          flex-direction: column;
          margin-right: 2rem;
          font-family: "Maersk Text";
          font-size: 14px;
          color: var(--Blue-900-Darkest);
          text-transform: capitalize;
          width: 180px;
          &__name {
            font-size: 16px;
            margin-bottom: 4px;
            &--bold {
              font-weight: bold;
            }
            &--grey {
              font-weight: bold;
              color: var(--Gray-600);
            }
            &--ellipsis {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .subject {
          width: 380px;
        }
      }
    }

    &__accordian-body {
      padding: 1rem;
      border: 1px solid var(--Gray-200);
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      display: flex;
      flex-direction: column;
      margin-left: 60px;
      cursor: default;

      @include media("<tablet") {
        margin-left: 40px;
      }

      &__item {
        display: flex;
        margin-bottom: 16px;
        flex-direction: column;
        &__title {
          color: var(--Gray-600);
          margin-bottom: 4px;
          font-size: 14px;
        }
        &__value {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
